// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".services-promocodes[data-v-58dd332b]{display:-webkit-box;display:-ms-flexbox;display:flex}.services-promocodes strong[data-v-58dd332b]{margin:auto 0}.services-promocodes .promocodes-select[data-v-58dd332b]{width:37%}.services-promocodes button[data-v-58dd332b]{border:1px solid #5b2ae0}", ""]);
// Exports
module.exports = exports;
